import { deepMerge } from 'utils/helpers';
import Table from 'core/table';
import {
  getWidgetFetchParams,
  getWidgetSettings,
} from 'modules/dashboard/utils/dashboardWidgetUtils';
import { defaultCampaignParams } from 'utils/campaigns';
import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import * as campaignColumns from './campaignColumns';

const StyledCoreTable = styled(Table)`
  height: 100%;
  padding: ${pxToRem(40)} ${pxToRem(10)} ${pxToRem(10)}; /** css file conversion */
  [data-role='table'] {
    position: relative;
    [data-role='header'],
    [data-role='row'] {
      width: auto !important;
    }
  }
`;

// type Props = {
//   /** Fetched data containing results and total to display on table. */
//   data: {},
//   /**
//    * Function to fetch campaigns.
//    *
//    * ```
//    * fetchCampaigns()
//    * ```
//    * @returns { void }
//    */
//   fetchCampaigns: () => void,
//   /** If widget is fetching campaigns. */
//   isFetchingCampaigns: boolean,
//   /** If widget is loading. */
//   isLoading: boolean,
//   /** If loading spinner is inverted. */
//   loadingInverted: boolean,
//   /**
//    * Function to save dashboard.
//    *
//    * ```
//    * saveDashboard()
//    * ```
//    * @returns { void }
//    */
//   saveDashboard: () => void,
//   /** Widget config data. */
//   widget: {},
// };

export const CampaignsTableWidget = (props) => {
  const {
    data = {
      fetchParams: defaultCampaignParams,
      results: [],
      total: 0,
    },
    fetchCampaigns = () => {},
    isFetchingCampaigns = false,
    isLoading,
    loadingInverted,
    saveDashboard = () => {},
    widget = { settings: { columns: ['name'], fetchParams: defaultCampaignParams } },
  } = props;

  /**
   * getColumns
   * Creates the columns to display on table.
   * @returns { Array }
   */
  const getColumns = () => {
    const { columns } = getWidgetSettings(widget);
    const tableColumns = Object.keys(campaignColumns).reduce((obj, column) => {
      const newObj = obj;
      newObj[campaignColumns[column].value] = campaignColumns[column];
      return newObj;
    }, {});
    const columnsToDisplay = [];

    Object.keys(tableColumns).forEach((columnName) => {
      if (columns.indexOf(columnName) !== -1) {
        columnsToDisplay.push(tableColumns[columnName]);
      }
    });
    return columnsToDisplay;
  };

  /**
   * handleFetch
   * Function to fetch campaigns with fetch params.
   * @param { Object } e: The change event to fetch params.
   * @param { Object } fetchParams: The fetch params.
   * @returns { void }
   */
  const handleFetch = (e, fetchParams) => {
    const params = { ...getWidgetFetchParams(widget, data), ...fetchParams };
    const updatedWidget = deepMerge({}, widget, {
      settings: { fetchParams: params },
    });
    fetchCampaigns({ fetchParams: params, widget: updatedWidget });
    saveDashboard();
  };

  /**
   * handleChangePageSize
   * Function to fetch campaigns with new page size. Resets page to 1.
   * @param { Object } e: The change event with updated page size.
   * @param { Object } fetchParams: The fetch params.
   * @returns { void }
   */
  const handleChangePageSize = (e, fetchParams) => {
    handleFetch(e, { ...fetchParams, page: 1 });
  };

  const { page, pageSize, orderBy, sorting } = getWidgetFetchParams(widget, data);

  return (
    <StyledCoreTable
      appearance="normal"
      columns={getColumns()}
      emptyStateHeader={isFetchingCampaigns ? '' : '0 Campaigns'}
      emptyStateText={isFetchingCampaigns ? '' : 'There are no campaigns to show'}
      isLoading={isLoading ? false : isFetchingCampaigns}
      loadingInverted={loadingInverted}
      onChangePage={handleFetch}
      onChangePageSize={handleChangePageSize}
      onChangeSort={handleFetch}
      orderBy={orderBy}
      page={page}
      pageSize={pageSize}
      pageSizes={[10, 25, 50]}
      rows={data.results}
      sorting={sorting}
      total={data.total}
    />
  );
};
